const LocalStorageKeys = {
  TOUR: {
    COMPOSE_AI: 'TOUR_COMPOSE_AI',
    GENERATE_IMAGE_AI: 'GENERATE_IMAGE_AI',
  },
}

// isSummarizeEnabled
function parseBool(key) {
  try {
    const value = localStorage.getItem(key)
    return value === 'true'
  } catch (error) {
    return false
  }
}

const localStorageService = {
  setComposeAITour: (value) => {
    localStorage.setItem(LocalStorageKeys.TOUR.COMPOSE_AI, value.toString())
  },
  getComposeAITour: () => {
    return parseBool(LocalStorageKeys.TOUR.COMPOSE_AI)
  },
  setGVAAITour: (value) => {
    localStorage.setItem(
      LocalStorageKeys.TOUR.GENERATE_IMAGE_AI,
      value.toString(),
    )
  },
  getGVAAITour: () => {
    return parseBool(LocalStorageKeys.TOUR.GENERATE_IMAGE_AI)
  },
  clearTours: () => {
    localStorage.removeItem(LocalStorageKeys.TOUR.COMPOSE_AI)
    localStorage.removeItem(LocalStorageKeys.TOUR.GENERATE_IMAGE_AI)
  },
}

export { localStorageService, LocalStorageKeys }
